export function classNames(...cls: (string | undefined)[]) {
  return cls
    .map((it) => it?.trim())
    .filter(Boolean)
    .join(' ');
}

// Alias for shadcn UI compatibility
export const cn = classNames;
